import {
  BREEDER_MISSION_DISPLAY_TYPE,
  GENERAL_MISSION_DISPLAY_TYPE
} from 'dpl/prismic/article/mission_callout/utils/constants';

export const HEADER_FEATURE_TYPES = {
  MISSION: GENERAL_MISSION_DISPLAY_TYPE,
  REVIEWER: 'reviewer',
  HIGHLIGHTS: 'highlights',
  BREEDER_MISSION: BREEDER_MISSION_DISPLAY_TYPE
};
